module.exports = __webpack_public_path__ + "img/tweet_like.20b9c609.svg";